/** 
 * Custom Validators for Vuelidate
 * @file
 */

const notHtmlEditorDefault = (value) => { 
	return (!value || value === '<p><br></p>') ? false : true
}

const jobNumberFormat = (value) => { 
	// Matches 3 alpha and at least 5 numberic characters
	return value ? (/\b[a-zA-Z]{3}[0-9]{3,}\b/i).test(value) : true
}


export {
	notHtmlEditorDefault,
	jobNumberFormat
}